const base =
  "w-full bg-transparent border-0 border-b border-[#d4d4d8] rounded-none px-0 py-3 text-base text-ink placeholder:text-mist focus:outline-none focus:ring-0";

export const Field = ({ id, label, multiline, className = "", ...props }) => (
  <div className={className}>
    <label htmlFor={id} className="block text-xs uppercase tracking-[0.2em] text-stone">
      {label}
      {props.required && <span className="ml-1 text-[#288B58]">*</span>}
    </label>
    <div className="field mt-2">
      {multiline ? (
        <textarea id={id} name={id} rows={4} data-testid={`contact-${id}-input`} className={`${base} resize-none`} {...props} />
      ) : (
        <input id={id} name={id} data-testid={`contact-${id}-input`} className={base} {...props} />
      )}
    </div>
  </div>
);

const OPTIONS = [
  { value: "new", label: "New" },
  { value: "used", label: "Pre-owned" },
  { value: "unsure", label: "Not sure yet" },
];

export const ConditionPicker = ({ value, onChange }) => (
  <div className="md:col-span-2" role="radiogroup" aria-label="New or pre-owned">
    <p className="text-xs uppercase tracking-[0.2em] text-stone">New or pre-owned</p>
    <div className="mt-4 flex flex-wrap gap-3">
      {OPTIONS.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={active}
            data-testid={`contact-condition-${o.value}`}
            onClick={() => onChange(active ? "" : o.value)}
            className={`border px-6 py-2.5 text-sm transition-colors duration-300 ${
              active ? "border-ink bg-ink text-ivory" : "border-[#d4d4d8] text-stone hover:border-ink hover:text-ink"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  </div>
);
